exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app.bar{display:flex;justify-content:space-between;position:relative;width:960px;max-width:100%}.app.bar .title{display:block;margin:0;height:72px;margin:auto 0}.app.bar .logo img{height:100%}.ui.right.item{padding-top:10px}@media only screen and (max-width:767px){.app.bar>.title{width:100%;text-align:center;margin:auto 0}.app.bar>.icon.menu{display:none}.app.bar>.right.item{width:100%;position:absolute;text-align:right}.app.bar .menu{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/GuanKiann/ToLam/ToLam.css
// module id = 656
// module chunks = 0